import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import IsotopesViewer from '../../../elements/IsotopesViewer';
import FormikColumnFormatField from '../../../elements/formik/FormikColumnFormatField';
const styles = {
    groupContainer: {
        padding: '5px',
        borderRadius: '5px',
        margin: '10px 0px',
        backgroundColor: 'white',
    },
    header: {
        borderBottom: '1px solid #e8e8e8',
        paddingBottom: '5px',
        fontWeight: 'bold',
        color: '#4a4a4a',
    },
};
export function NucleusPreferences({ nucleus, fields, renderTop, renderBottom, }) {
    return (_jsxs("div", { style: styles.groupContainer, children: [_jsx(IsotopesViewer, { style: styles.header, value: nucleus }), renderTop?.(), fields.map((field) => (_jsx(FormikColumnFormatField, { label: field.label, checkControllerName: field.checkControllerName &&
                    `nuclei.${nucleus}.${field.checkControllerName}`, formatControllerName: field.formatControllerName &&
                    `nuclei.${nucleus}.${field.formatControllerName}`, hideCheckField: field.hideCheckField, hideFormatField: field.hideFormatField, disableFormat: field.disableFormat }, field.id))), renderBottom?.()] }, nucleus));
}
